/**
 * OrbDocGettingStartedIntroductionARDocEx1CountingView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocGettingStartedIntroductionARDocEx1Counting
 */

import { useOrbDocGettingStartedIntroductionARDocEx1CountingLogic } from '@/hooks/traits/useOrbDocGettingStartedIntroductionARDocEx1CountingLogic';
import type { OrbDocGettingStartedIntroductionARDocEx1CountingConfig } from '@/hooks/traits/useOrbDocGettingStartedIntroductionARDocEx1CountingLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocGettingStartedIntroductionARCounter } from '@app/shared';
import { Button } from '@almadar/ui/components';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocGettingStartedIntroductionARDocEx1CountingViewProps {
  config?: Partial<OrbDocGettingStartedIntroductionARDocEx1CountingConfig>;
}

export function OrbDocGettingStartedIntroductionARDocEx1CountingView({ config: propsConfig }: OrbDocGettingStartedIntroductionARDocEx1CountingViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocGettingStartedIntroductionARDocEx1CountingLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocGettingStartedIntroductionARCounter'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocGettingStartedIntroductionAR" trait="OrbDocGettingStartedIntroductionARDocEx1Counting">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="horizontal" gap="md" align="center"><Button label="−" action="OrbDocGettingStartedIntroductionAR.OrbDocGettingStartedIntroductionARDocEx1Counting.DECREMENT" variant="secondary" aria-label="Decrease" /><Typography content={String(fields?.count ?? '')} variant="h2" /><Button label="+" action="OrbDocGettingStartedIntroductionAR.OrbDocGettingStartedIntroductionARDocEx1Counting.INCREMENT" variant="primary" aria-label="Increase" /><Button label="Reset" action="OrbDocGettingStartedIntroductionAR.OrbDocGettingStartedIntroductionARDocEx1Counting.RESET" variant="ghost" /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default OrbDocGettingStartedIntroductionARDocEx1CountingView;
